import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleplay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14 14",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(-341 -1216.112)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(341 1216.112)",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M7.8,7L1.4,0.6v12.8L7.8,7 M1.9,0l6.5,6.5l1.5-1.6L9.8,4.8l-5-3.2C4,1.1,3.2,0.6,2.5,0.1 C2.3,0,2.1,0,1.9,0 M1.9,14c0.2,0,0.4,0,0.6-0.2c2.4-1.5,4.9-3.1,7.3-4.6c0,0,0.1-0.1,0.1-0.1l0,0L8.4,7.5L1.9,14",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.8,7l-6.4,6.4V0.6L7.8,7",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.9,0c0.2,0,0.4,0,0.5,0.1c0.8,0.5,1.6,1,2.3,1.5l5,3.2l0.1,0.1L8.4,6.5L1.9,0",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.9,14l6.4-6.5l1.5,1.6l0,0c0,0-0.1,0.1-0.1,0.1c-2.4,1.5-4.9,3.1-7.3,4.6 C2.3,14,2.1,14,1.9,14",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6,8.7L8.8,7l1.7-1.7l0,0l0.2,0.1c0.5,0.3,1,0.6,1.5,0.9c0.4,0.2,0.5,0.6,0.3,1 c-0.1,0.1-0.2,0.3-0.3,0.3C11.7,8,11.1,8.4,10.6,8.7",
					fill: "currentColor"
				})
			] }) })
		})
	})
});
export { SvgGoogleplay as ReactComponent };
